import { func, object, string } from 'prop-types';
import React from 'react';
import { path } from 'ramda';

import QuestionBlock from './QuestionBlock';
import ControlSteps from '../../OnlineRehabilitation/components/Contents/components/ControlSteps';
import RehabHeader from './RehabHeader';
import { Col, Row } from 'react-flexbox-grid';
import TextFieldArea from 'components/TextFieldArea';
import ActionButton from 'components/ActionButton';

const TextInputArea = ({ value, onChange, onSave }) => (
  <Row>
    <Col xs={7}>
      <TextFieldArea editing input={{ value, onChange }} rows={4} style={{ width: '100%' }} />
    </Col>
    <Col xs={5}>
      <Row style={{ marginLeft: '4rem', marginTop: '0.8rem' }}>
        <Col>{onSave && <ActionButton localeId="npView.history.save" onClick={onSave} secondary border />}</Col>
      </Row>
    </Col>
  </Row>
);
TextInputArea.propTypes = {
  value: string,
  onChange: func,
  onSave: func,
};

const Rehab6 = ({ fm, data, dataFinished, commitPutRehab }) => {
  const controlStepsDataNew = {
    currentStatus: path(['currentStatus'], data),
    clearlyWorseStatus: path(['clearlyWorseStatus'], data),
    nearFutureTarget: path(['nearFutureTarget'], data),
    betterStatus: path(['betterStatus'], data),
    clearlyBetterStatus: path(['clearlyBetterStatus'], data),
  };

  const [text, setText] = React.useState(null);

  const savedFeedbackText = path(['answerFromNeurologist'], dataFinished);
  const feedbackValue = text || savedFeedbackText || '';

  const onChangeText = event => {
    const eventValue = path(['currentTarget', 'value'], event);
    setText(eventValue);
  };

  const onSave =
    savedFeedbackText !== feedbackValue
      ? () => {
          commitPutRehab({ rehab6: { ...data, answerFromNeurologist: text } });
          setText(null);
        }
      : null;

  return (
    <React.Fragment>
      <RehabHeader fm={fm} rehab={6} date={data.finished} />

      <QuestionBlock
        question={fm('onlineRehabilitation.rehab6.1.question')}
        answer={data.followedPlan === false || data.followedPlan ? fm(`npView.${data.followedPlan}`) : null}
      />
      <QuestionBlock
        question={fm('npView.rehab6.now')}
        answer={
          data.currentStatusSelected
            ? fm(`onlineRehabilitation.controlSteps.cognition.${data.currentStatusSelected}`)
            : null
        }
      />

      <QuestionBlock
        question={fm('npView.rehab6.newSteps')}
        answer={<ControlSteps steps={controlStepsDataNew} fm={fm} cognition />}
      />
      <QuestionBlock question={fm('npView.rehab6.newMeans')} answer={data.plannedChangesToManageCognitiveProblems} />

      <QuestionBlock question={fm('onlineRehabilitation.rehab6.4.personToShowPlan')} answer={data.personToShowPlan} />

      <QuestionBlock question={fm('npView.question')} answer={data.questionToNeurologist} />

      <QuestionBlock
        question={fm('npView.answer')}
        answer={<TextInputArea value={feedbackValue} onChange={onChangeText} onSave={onSave} />}
      />
    </React.Fragment>
  );
};

Rehab6.propTypes = {
  fm: func,
  data: object,
  dataFinished: object,
  commitPutRehab: func,
};
export default Rehab6;
